<script setup lang="ts">
  import { type PropType, computed } from 'vue';
  import type { PotaParkType } from '@/types';

  const props = defineProps({
    park: {
      type: Object as PropType<PotaParkType>,
      required: true
    }
  });
  const location = computed(() => {
    let location = ''
    const locations = props.park.location.split(',');
    if (locations.length == 1) {
      location = locations[0];
    } else {
      location = `${locations[0]}, +${locations.length - 1} more`;
    }
    return location
  });
</script>

<template>
  <div data-testid="toast">
    <div data-testid="toast__header" class="font-bold text-sm mb-1 flex">
      <span data-testid="toast__badge"
        class="inline-flex items-center text-green-600 rounded-md bg-gray-100 px-1.5 py-0.5 text-xs font-bold uppercase">
        POTA
      </span>
      <span data-testid="toast__title" class="ml-2 text-base font-mono">
        {{ props.park.id }}
      </span>
    </div>
    <div data-testid="toast__body">
      <div class="font-semibold titlecase text-sm">{{ props.park.name }} </div>
      <div class="font-medium titlecase text-sm mt-1 font-mono">
        <i class="fa-solid fa-earth-americas"></i> {{ location }}
        <i class="fa-sharp-duotone fa-solid fa-location-crosshairs ml-2"></i> {{ props.park.grid
        }}
      </div>
    </div>
  </div>
</template>
